import React from 'react';

// AUTHENTIC Windows 95 Icons - 48x48 pixel-perfect style
// Based on real Windows 95 desktop icons with larger size for better visibility

// Windows 95 Start Button Logo (classic waving flag)
export const WindowsLogo = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" style={{ imageRendering: 'pixelated' }}>
    {/* Classic 4-color Windows flag */}
    <rect x="1" y="1" width="6" height="6" fill="#FF0000" />
    <rect x="8" y="1" width="6" height="6" fill="#00FF00" />
    <rect x="1" y="8" width="6" height="6" fill="#0000FF" />
    <rect x="8" y="8" width="6" height="6" fill="#FFFF00" />
    {/* Divider lines */}
    <rect x="7" y="0" width="1" height="16" fill="#000" />
    <rect x="0" y="7" width="16" height="1" fill="#000" />
  </svg>
);

// My Computer - Classic beige monitor with Windows logo - 48x48
export const MyComputerIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Monitor body - cream/beige */}
    <rect x="4" y="2" width="40" height="28" fill="#C0C0C0" />
    {/* 3D highlights */}
    <rect x="4" y="2" width="40" height="2" fill="#FFFFFF" />
    <rect x="4" y="2" width="2" height="28" fill="#FFFFFF" />
    {/* 3D shadows */}
    <rect x="42" y="4" width="2" height="26" fill="#808080" />
    <rect x="6" y="28" width="38" height="2" fill="#808080" />
    
    {/* Screen bezel */}
    <rect x="7" y="5" width="34" height="21" fill="#808080" />
    <rect x="8" y="6" width="32" height="19" fill="#000000" />
    
    {/* Screen - teal desktop color */}
    <rect x="9" y="7" width="30" height="17" fill="#008080" />
    
    {/* Windows logo on screen */}
    <rect x="18" y="10" width="5" height="5" fill="#FF0000" />
    <rect x="24" y="10" width="5" height="5" fill="#00FF00" />
    <rect x="18" y="16" width="5" height="5" fill="#0000FF" />
    <rect x="24" y="16" width="5" height="5" fill="#FFFF00" />
    
    {/* Monitor stand */}
    <rect x="18" y="30" width="12" height="3" fill="#808080" />
    
    {/* Monitor base */}
    <rect x="12" y="33" width="24" height="4" fill="#C0C0C0" />
    <rect x="12" y="33" width="24" height="1" fill="#FFFFFF" />
    <rect x="35" y="34" width="1" height="3" fill="#808080" />
    
    {/* Keyboard */}
    <rect x="6" y="38" width="36" height="8" fill="#C0C0C0" />
    <rect x="6" y="38" width="36" height="1" fill="#FFFFFF" />
    <rect x="6" y="38" width="1" height="8" fill="#FFFFFF" />
    <rect x="41" y="39" width="1" height="7" fill="#808080" />
    <rect x="7" y="45" width="34" height="1" fill="#808080" />
    {/* Keys */}
    <rect x="8" y="40" width="32" height="4" fill="#404040" />
  </svg>
);

// Network Neighborhood - Two connected computers
export const NetworkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Back computer */}
    <rect x="24" y="2" width="22" height="18" fill="#000080" />
    <rect x="24" y="2" width="22" height="2" fill="#0000FF" />
    <rect x="24" y="2" width="2" height="18" fill="#0000FF" />
    <rect x="26" y="4" width="18" height="14" fill="#0000C0" />
    {/* Screen */}
    <rect x="28" y="6" width="14" height="10" fill="#008080" />
    
    {/* Front computer */}
    <rect x="2" y="10" width="22" height="18" fill="#000080" />
    <rect x="2" y="10" width="22" height="2" fill="#0000FF" />
    <rect x="2" y="10" width="2" height="18" fill="#0000FF" />
    <rect x="4" y="12" width="18" height="14" fill="#0000C0" />
    {/* Screen */}
    <rect x="6" y="14" width="14" height="10" fill="#008080" />
    
    {/* Connection cable/bar */}
    <rect x="8" y="30" width="32" height="4" fill="#808080" />
    <rect x="8" y="30" width="32" height="1" fill="#C0C0C0" />
    
    {/* Cable to computers */}
    <rect x="12" y="28" width="3" height="2" fill="#808080" />
    <rect x="33" y="20" width="3" height="10" fill="#808080" />
    
    {/* Base connectors */}
    <rect x="6" y="34" width="10" height="6" fill="#C0C0C0" />
    <rect x="6" y="34" width="10" height="1" fill="#FFFFFF" />
    <rect x="32" y="34" width="10" height="6" fill="#C0C0C0" />
    <rect x="32" y="34" width="10" height="1" fill="#FFFFFF" />
    
    {/* Earth/globe symbol on front computer */}
    <circle cx="13" cy="19" r="4" fill="#00AA00" />
    <ellipse cx="13" cy="19" rx="4" ry="1.5" fill="none" stroke="#FFFFFF" strokeWidth="1" />
    <line x1="13" y1="15" x2="13" y2="23" stroke="#FFFFFF" strokeWidth="1" />
  </svg>
);

// Inbox - Paper tray with documents
export const InboxIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Back paper (yellow tinted) */}
    <rect x="8" y="4" width="26" height="20" fill="#FFFFCC" transform="rotate(-5 21 14)" />
    
    {/* Main document */}
    <rect x="10" y="6" width="28" height="26" fill="#FFFFFF" />
    <rect x="10" y="6" width="28" height="2" fill="#FFFFFF" />
    <rect x="10" y="6" width="2" height="26" fill="#FFFFFF" />
    <rect x="36" y="8" width="2" height="24" fill="#808080" />
    <rect x="12" y="30" width="26" height="2" fill="#808080" />
    
    {/* Red folder tab/bookmark */}
    <rect x="10" y="6" width="8" height="10" fill="#FF0000" />
    <rect x="10" y="6" width="8" height="2" fill="#FF6666" />
    
    {/* Text lines */}
    <rect x="20" y="10" width="16" height="2" fill="#000000" />
    <rect x="20" y="14" width="14" height="2" fill="#808080" />
    <rect x="20" y="18" width="15" height="2" fill="#808080" />
    <rect x="20" y="22" width="12" height="2" fill="#808080" />
    <rect x="20" y="26" width="14" height="2" fill="#808080" />
    
    {/* Tray */}
    <rect x="2" y="32" width="44" height="14" fill="#C0C0C0" />
    <rect x="2" y="32" width="44" height="2" fill="#FFFFFF" />
    <rect x="2" y="32" width="2" height="14" fill="#FFFFFF" />
    <rect x="44" y="34" width="2" height="12" fill="#808080" />
    <rect x="4" y="44" width="42" height="2" fill="#808080" />
  </svg>
);

// Recycle Bin - Authentic Win95 trash can
export const RecycleBinIcon = ({ empty = true }) => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Lid */}
    <rect x="8" y="4" width="32" height="8" fill="#C0C0C0" />
    <rect x="8" y="4" width="32" height="2" fill="#FFFFFF" />
    <rect x="8" y="4" width="2" height="8" fill="#FFFFFF" />
    <rect x="38" y="6" width="2" height="6" fill="#808080" />
    <rect x="10" y="10" width="28" height="2" fill="#808080" />
    
    {/* Lid handle */}
    <rect x="18" y="0" width="12" height="5" fill="#808080" />
    <rect x="20" y="1" width="8" height="3" fill="#C0C0C0" />
    
    {/* Bin body */}
    <rect x="10" y="13" width="28" height="32" fill="#C0C0C0" />
    <rect x="10" y="13" width="28" height="2" fill="#FFFFFF" />
    <rect x="10" y="13" width="2" height="32" fill="#FFFFFF" />
    <rect x="36" y="15" width="2" height="30" fill="#808080" />
    <rect x="12" y="43" width="26" height="2" fill="#808080" />
    
    {/* Recycling arrows (simplified) */}
    <polygon points="24,20 30,28 26,28 26,36 22,36 22,28 18,28" fill="#008000" />
    <rect x="20" y="22" width="8" height="2" fill="#00AA00" />
    <rect x="22" y="30" width="4" height="4" fill="#00CC00" />
    
    {/* Paper sticking out if not empty */}
    {!empty && (
      <>
        <rect x="14" y="6" width="8" height="6" fill="#FFFFFF" transform="rotate(-10 18 9)" />
        <rect x="26" y="5" width="6" height="5" fill="#FFFFCC" transform="rotate(8 29 7)" />
      </>
    )}
  </svg>
);

// The Internet - Globe with magnifying glass
export const InternetIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Globe */}
    <circle cx="20" cy="22" r="18" fill="#008800" />
    <circle cx="20" cy="22" r="16" fill="#00AA00" />
    
    {/* Globe highlight */}
    <ellipse cx="14" cy="16" rx="6" ry="4" fill="#00CC00" />
    
    {/* Continents suggestion */}
    <ellipse cx="16" cy="18" rx="8" ry="4" fill="#00BB00" />
    <ellipse cx="24" cy="26" rx="6" ry="5" fill="#009900" />
    
    {/* Latitude lines */}
    <ellipse cx="20" cy="22" rx="16" ry="5" fill="none" stroke="#FFFFFF" strokeWidth="1" opacity="0.4" />
    <ellipse cx="20" cy="22" rx="16" ry="10" fill="none" stroke="#FFFFFF" strokeWidth="1" opacity="0.4" />
    
    {/* Longitude line */}
    <ellipse cx="20" cy="22" rx="8" ry="16" fill="none" stroke="#FFFFFF" strokeWidth="1" opacity="0.4" />
    <line x1="4" y1="22" x2="36" y2="22" stroke="#FFFFFF" strokeWidth="1" opacity="0.4" />
    <line x1="20" y1="6" x2="20" y2="38" stroke="#FFFFFF" strokeWidth="1" opacity="0.4" />
    
    {/* Magnifying glass handle */}
    <rect x="34" y="34" width="12" height="5" fill="#808080" transform="rotate(45 40 36)" />
    <rect x="34" y="34" width="12" height="2" fill="#C0C0C0" transform="rotate(45 40 35)" />
    
    {/* Magnifying glass rim */}
    <circle cx="30" cy="30" r="10" fill="none" stroke="#808080" strokeWidth="4" />
    <circle cx="30" cy="30" r="10" fill="none" stroke="#C0C0C0" strokeWidth="2" />
    
    {/* Magnifying glass lens */}
    <circle cx="30" cy="30" r="7" fill="#AADDFF" opacity="0.4" />
    <ellipse cx="27" cy="27" rx="2" ry="1.5" fill="#FFFFFF" />
  </svg>
);

// Winamp - Lightning bolt on dark background
export const WinampIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Dark background */}
    <rect x="2" y="2" width="44" height="44" rx="3" fill="#1A1A1A" />
    <rect x="2" y="2" width="44" height="2" fill="#333" />
    <rect x="2" y="2" width="2" height="44" fill="#333" />
    <rect x="44" y="4" width="2" height="42" fill="#000" />
    <rect x="4" y="44" width="42" height="2" fill="#000" />
    
    {/* Lightning bolt */}
    <polygon points="28,4 14,24 22,24 16,44 36,20 26,20 32,4" fill="#FFD700" />
    <polygon points="27,6 16,22 22,22 18,40 33,21 25,21 30,6" fill="#FFFF00" />
    
    {/* Inner highlight */}
    <polygon points="26,10 20,20 23,20 20,34 30,22 25,22 28,10" fill="#FFFFAA" />
    
    {/* Sparkles */}
    <rect x="8" y="8" width="4" height="4" fill="#FFFF88" />
    <rect x="36" y="10" width="3" height="3" fill="#FFFF88" />
    <rect x="6" y="32" width="3" height="3" fill="#FFFF88" />
    <rect x="38" y="34" width="4" height="4" fill="#FFFF88" />
  </svg>
);

// Document / Notepad icon
export const DocumentIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Paper */}
    <rect x="8" y="2" width="32" height="44" fill="#FFFFFF" />
    <rect x="8" y="2" width="32" height="2" fill="#FFFFFF" />
    <rect x="8" y="2" width="2" height="44" fill="#FFFFFF" />
    <rect x="38" y="4" width="2" height="42" fill="#808080" />
    <rect x="10" y="44" width="30" height="2" fill="#808080" />
    
    {/* Folded corner */}
    <polygon points="30,2 40,2 40,12 30,12" fill="#C0C0C0" />
    <line x1="30" y1="2" x2="40" y2="12" stroke="#808080" strokeWidth="2" />
    
    {/* Blue notepad header */}
    <rect x="12" y="6" width="16" height="6" fill="#000080" />
    
    {/* Text lines */}
    <rect x="12" y="16" width="24" height="2" fill="#000000" />
    <rect x="12" y="22" width="20" height="2" fill="#808080" />
    <rect x="12" y="28" width="22" height="2" fill="#808080" />
    <rect x="12" y="34" width="18" height="2" fill="#808080" />
    <rect x="12" y="40" width="20" height="2" fill="#808080" />
  </svg>
);

// Mail/Contact envelope
export const MailIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Envelope body */}
    <rect x="2" y="10" width="44" height="32" fill="#FFFFCC" />
    <rect x="2" y="10" width="44" height="2" fill="#FFFFEE" />
    <rect x="2" y="10" width="2" height="32" fill="#FFFFEE" />
    <rect x="44" y="12" width="2" height="30" fill="#CCCC99" />
    <rect x="4" y="40" width="42" height="2" fill="#CCCC99" />
    
    {/* Envelope flap */}
    <polygon points="2,10 24,26 46,10" fill="#FFFF99" />
    <line x1="2" y1="10" x2="24" y2="26" stroke="#CCCC66" strokeWidth="2" />
    <line x1="46" y1="10" x2="24" y2="26" stroke="#CCCC66" strokeWidth="2" />
    
    {/* Stamp */}
    <rect x="34" y="14" width="10" height="10" fill="#FFFFFF" stroke="#808080" strokeWidth="1" />
    <rect x="36" y="16" width="6" height="6" fill="#000080" />
    
    {/* Address lines */}
    <rect x="6" y="28" width="18" height="2" fill="#808080" />
    <rect x="6" y="32" width="14" height="2" fill="#808080" />
    <rect x="6" y="36" width="10" height="2" fill="#808080" />
  </svg>
);

// Minesweeper mine
export const GameIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Mine body */}
    <circle cx="24" cy="24" r="12" fill="#000000" />
    
    {/* Spikes */}
    <rect x="22" y="4" width="4" height="10" fill="#000000" />
    <rect x="22" y="34" width="4" height="10" fill="#000000" />
    <rect x="4" y="22" width="10" height="4" fill="#000000" />
    <rect x="34" y="22" width="10" height="4" fill="#000000" />
    
    {/* Diagonal spikes */}
    <rect x="8" y="8" width="8" height="3" fill="#000000" transform="rotate(45 12 10)" />
    <rect x="32" y="8" width="8" height="3" fill="#000000" transform="rotate(-45 36 10)" />
    <rect x="8" y="37" width="8" height="3" fill="#000000" transform="rotate(-45 12 38)" />
    <rect x="32" y="37" width="8" height="3" fill="#000000" transform="rotate(45 36 38)" />
    
    {/* Highlight */}
    <circle cx="19" cy="19" r="5" fill="#FFFFFF" />
  </svg>
);

// MS-DOS Prompt
export const TerminalIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Window frame */}
    <rect x="2" y="2" width="44" height="44" fill="#000000" />
    <rect x="2" y="2" width="44" height="2" fill="#404040" />
    <rect x="2" y="2" width="2" height="44" fill="#404040" />
    
    {/* DOS text */}
    <text x="6" y="20" fill="#C0C0C0" fontSize="14" fontFamily="monospace" fontWeight="bold">C:\&gt;_</text>
    <text x="6" y="36" fill="#808080" fontSize="12" fontFamily="monospace">dir</text>
  </svg>
);

// Video/Film icon
export const VideoIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Film strip */}
    <rect x="4" y="2" width="40" height="44" fill="#404040" />
    
    {/* Sprocket holes left */}
    <rect x="6" y="6" width="5" height="4" fill="#FFFFFF" />
    <rect x="6" y="14" width="5" height="4" fill="#FFFFFF" />
    <rect x="6" y="22" width="5" height="4" fill="#FFFFFF" />
    <rect x="6" y="30" width="5" height="4" fill="#FFFFFF" />
    <rect x="6" y="38" width="5" height="4" fill="#FFFFFF" />
    
    {/* Sprocket holes right */}
    <rect x="37" y="6" width="5" height="4" fill="#FFFFFF" />
    <rect x="37" y="14" width="5" height="4" fill="#FFFFFF" />
    <rect x="37" y="22" width="5" height="4" fill="#FFFFFF" />
    <rect x="37" y="30" width="5" height="4" fill="#FFFFFF" />
    <rect x="37" y="38" width="5" height="4" fill="#FFFFFF" />
    
    {/* Frame 1 */}
    <rect x="14" y="6" width="20" height="16" fill="#000080" />
    <polygon points="20,10 20,18 28,14" fill="#FFFFFF" />
    
    {/* Frame 2 */}
    <rect x="14" y="26" width="20" height="16" fill="#808080" />
  </svg>
);

// Services/Settings gear
export const ServicesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Gear teeth */}
    <rect x="19" y="2" width="10" height="8" fill="#808080" />
    <rect x="19" y="38" width="10" height="8" fill="#808080" />
    <rect x="2" y="19" width="8" height="10" fill="#808080" />
    <rect x="38" y="19" width="8" height="10" fill="#808080" />
    
    <rect x="6" y="6" width="8" height="6" fill="#808080" transform="rotate(45 10 9)" />
    <rect x="34" y="6" width="8" height="6" fill="#808080" transform="rotate(-45 38 9)" />
    <rect x="6" y="36" width="8" height="6" fill="#808080" transform="rotate(-45 10 39)" />
    <rect x="34" y="36" width="8" height="6" fill="#808080" transform="rotate(45 38 39)" />
    
    {/* Main gear body */}
    <circle cx="24" cy="24" r="14" fill="#C0C0C0" />
    <circle cx="24" cy="24" r="13" stroke="#FFFFFF" strokeWidth="2" fill="none" />
    
    {/* Center hole */}
    <circle cx="24" cy="24" r="6" fill="#404040" />
  </svg>
);

// Chart/Metrics
export const ChartIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Background */}
    <rect x="4" y="4" width="40" height="40" fill="#FFFFFF" />
    <rect x="4" y="4" width="40" height="2" fill="#FFFFFF" />
    <rect x="4" y="4" width="2" height="40" fill="#FFFFFF" />
    <rect x="42" y="6" width="2" height="38" fill="#808080" />
    <rect x="6" y="42" width="38" height="2" fill="#808080" />
    
    {/* Grid lines */}
    <rect x="8" y="12" width="32" height="1" fill="#C0C0C0" />
    <rect x="8" y="22" width="32" height="1" fill="#C0C0C0" />
    <rect x="8" y="32" width="32" height="1" fill="#C0C0C0" />
    
    {/* Bars */}
    <rect x="12" y="24" width="8" height="14" fill="#0000FF" />
    <rect x="22" y="16" width="8" height="22" fill="#00FF00" />
    <rect x="32" y="10" width="8" height="28" fill="#FF0000" />
    
    {/* Axes */}
    <rect x="8" y="8" width="2" height="32" fill="#000000" />
    <rect x="8" y="38" width="32" height="2" fill="#000000" />
  </svg>
);

// Users/About (two people)
export const UsersIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Person 1 head */}
    <circle cx="14" cy="12" r="8" fill="#FFCC99" stroke="#808080" strokeWidth="1" />
    
    {/* Person 1 body */}
    <ellipse cx="14" cy="36" rx="10" ry="10" fill="#0000FF" />
    <ellipse cx="14" cy="36" rx="8" ry="8" fill="#000080" />
    
    {/* Person 2 head */}
    <circle cx="34" cy="12" r="8" fill="#FFCC99" stroke="#808080" strokeWidth="1" />
    
    {/* Person 2 body */}
    <ellipse cx="34" cy="36" rx="10" ry="10" fill="#00FF00" />
    <ellipse cx="34" cy="36" rx="8" ry="8" fill="#008000" />
  </svg>
);

// Sparkles/Welcome star
export const SparklesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Main 4-pointed star */}
    <polygon points="24,2 28,18 44,24 28,30 24,46 20,30 4,24 20,18" fill="#FFD700" />
    <polygon points="24,6 27,18 40,24 27,30 24,42 21,30 8,24 21,18" fill="#FFFF00" />
    
    {/* Center glow */}
    <circle cx="24" cy="24" r="4" fill="#FFFFFF" />
    
    {/* Small sparkles */}
    <rect x="8" y="6" width="5" height="5" fill="#FFFF00" transform="rotate(45 10 8)" />
    <rect x="36" y="8" width="4" height="4" fill="#FFFF00" transform="rotate(45 38 10)" />
    <rect x="8" y="36" width="4" height="4" fill="#FFFF00" transform="rotate(45 10 38)" />
    <rect x="36" y="36" width="5" height="5" fill="#FFFF00" transform="rotate(45 38 38)" />
  </svg>
);

// Magic Wand (App Builder)
export const WandIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Wand stick */}
    <rect x="2" y="38" width="32" height="6" fill="#4A3728" transform="rotate(-45 18 41)" />
    <rect x="2" y="38" width="32" height="3" fill="#6B5344" transform="rotate(-45 18 40)" />
    
    {/* Star tip */}
    <polygon points="38,4 40,10 46,12 40,14 38,20 36,14 30,12 36,10" fill="#FFD700" />
    <polygon points="38,6 39,10 44,12 39,14 38,18 37,14 32,12 37,10" fill="#FFFF00" />
    
    {/* Center of star */}
    <circle cx="38" cy="12" r="2" fill="#FFFFFF" />
    
    {/* Sparkles */}
    <rect x="28" y="2" width="4" height="4" fill="#FFFF88" />
    <rect x="42" y="6" width="4" height="4" fill="#FFFF88" />
    <rect x="42" y="18" width="3" height="3" fill="#FFFF88" />
    <rect x="24" y="12" width="3" height="3" fill="#FFFF88" />
    <rect x="18" y="18" width="3" height="3" fill="#FFFF88" />
  </svg>
);

// Folder
export const FolderIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" style={{ imageRendering: 'pixelated' }}>
    {/* Tab */}
    <rect x="2" y="8" width="16" height="6" fill="#FFC800" />
    <rect x="2" y="8" width="16" height="2" fill="#FFE066" />
    
    {/* Folder body */}
    <rect x="2" y="13" width="44" height="30" fill="#FFC800" />
    <rect x="2" y="13" width="44" height="2" fill="#FFE066" />
    <rect x="2" y="13" width="2" height="30" fill="#FFE066" />
    <rect x="44" y="15" width="2" height="28" fill="#C09800" />
    <rect x="4" y="41" width="42" height="2" fill="#C09800" />
  </svg>
);

export default {
  WindowsLogo,
  MyComputerIcon,
  NetworkIcon,
  InboxIcon,
  RecycleBinIcon,
  InternetIcon,
  WinampIcon,
  FolderIcon,
  DocumentIcon,
  MailIcon,
  GameIcon,
  TerminalIcon,
  VideoIcon,
  ServicesIcon,
  ChartIcon,
  UsersIcon,
  SparklesIcon,
  WandIcon
};
